var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6333",
    "data-name": "Group 6333",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.115,
    height: 25.723,
    viewBox: "0 0 24.115 25.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M828.825,120.017a.8.8,0,0,0,1.209,0l5.627-6.431a.8.8,0,0,0-.6-1.333h-3.215V101.8a.8.8,0,0,0-.8-.8h-3.216a.8.8,0,0,0-.8.8v10.45H823.8a.8.8,0,0,0-.6,1.333l5.627,6.431Z",
    transform: "translate(-817.371 -101)",
    fill: "#039be5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M731.9,453v4.823H714.215V453H711v6.431a1.607,1.607,0,0,0,1.608,1.608h20.9a1.606,1.606,0,0,0,1.608-1.608V453Z",
    transform: "translate(-711 -435.316)",
    fill: "#039be5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconOld);
export default __webpack_public_path__ + "static/media/downloadIcon-old.d5f62fdcb8be40fd2162b7f018a3c14c.svg";
export { ForwardRef as ReactComponent };